<template>
  <div>
      <!-- 公共搜索 -->
      <div class="search-box">
        <div class="input-box">
          <div class="search-btn" ></div>
          <input type="text" readonly @click="toSearch()" placeholder="请输入要查找的内容" v-bind:value="categoryName"/>
        </div>
      </div>

      <div class="category-content-box" :class="'fixed'">
        <pull-refresh :refreshing="isRefreshing" :on-refresh="onRefresh">
          <van-list
                  v-model="loading"
                  :finished="finished"
                  :immediate-check="false"
                  :finished-text="'没有更多了'"
                  :offset="10"
                  @load="onLoads"
                  class="category-content"
                  v-if="categoryDataList.length > 0">
            <li v-for="(itemData, i) in categoryDataList" :key="i">
              <router-link :to="{path: '/product-detail', query: {id: itemData._id}}">
                <div class="img-box dg-no-photo">
                  <img :src="itemData.comImage[0].url" v-if="itemData.comImage[0].url" width="100%" height="100%"/>
                </div>
                <div class="p-name">
                  <span class="group_tag" v-if="itemData.groupBuy.groupBuyComm">[拼团购]</span>
                  {{itemData.comName || '未知'}}
                </div>
              </router-link>
            </li>
          </van-list>
          <div class="dg-no-data" v-if="flag">暂无数据</div>
        </pull-refresh>
      </div>

    <category-search-pop ref="searchPop" v-bind:on-select="changeTabbar"></category-search-pop>
  </div>
</template>
<script>
  import api from '@/server'
  import pullRefresh from "@/components/pullRefresh.vue";
  import categorySearchPop from "./category-search-pop";

  export default {
    data() {
      return {
        searchBarFixed: 0,
        // 请求分类接口参数
        params: {
          pageSize: 8,
          pageNumber: 1,
          // category: '',
          cateId:''
        },
        // 分类列表数据
        categoryDataList: [],
        // 总页数
        totalPage: 0,
        // 滚动加载是否加载完成
        finished: false,
        // 滚动加载是否正在加载状态
        loading: false,
        // 暂无数据显示或者隐藏
        flag: false,
        // 下拉刷新状态
        isRefreshing: false,
        categoryName: "",
      };
    },
    deactivated() {
      this.flag = false;
    },
    components: {
      pullRefresh,
      categorySearchPop    
    },
    methods: {
      // 点击左边nav   切换
      changeTabbar(item) {
        this.down = false;
       
        this.params.pageNumber = 1;
        this.categoryDataList = [];
        this.finished = false;
        this.loading = false;
        this.flag = false;
        this.params.cateId = item._id;
        this.categoryName = item.category;
        this.getCommdityColumnList();

        this.$refs.searchPop.hide();
      },
      // 获取分类列表
      getCommdityColumnList(type) {
        api.classifyLists(this.params).then(res => {
          let data = res.data.commondityList;
          // 判断是滚动加载还是条件查询加载
          if (type === 'scroll') {
            this.categoryDataList = this.categoryDataList.concat(data);
            this.loading = false
          } else {
            if (res.code === 200 && data.length > 0) {
              this.categoryDataList = data;
              this.totalPage = res.data.pageInfo.totalPageNumber
            } else {
              this.categoryDataList = [];
              this.flag = true
            }
          }
          this.isRefreshing  = false;
        }).catch(err => {
          this.flag = true;
          this.isRefreshing  = false;
          console.error(err)
        })
      },
      // 滚动加载
      onLoads() {
        this.params.pageNumber++;
        if (this.params.pageNumber > this.totalPage) {
          this.finished = true;
           this.params.pageNumber--;
        } else {
          this.getCommdityColumnList('scroll')
        }
      },
      // 下拉刷新
      onRefresh() {
        this.isRefreshing = true;     
        this.params.pageNumber = 1;
        this.finished = false;
        this.loading = false;
        this.flag = false;
        this.getCommdityColumnList();
      },

      toSearch(){
        this.$refs.searchPop.open()
      }
    },
  };
</script>

<style lang="scss">
  .fixed {
    .category-box {
      position: fixed;
      top: 88px;
      z-index: 99;
    }
  }

  .category-content-box {
    padding-bottom: 130px;
    overflow: hidden;
    .pull-refresh{
      margin-top: 88px;
    }
    .on {
      transition: all .1s linear;
      height: auto !important;
      background: rgba(247, 105, 134, .8) !important;
    }

    .category-box {
      width: calc(100% + 10px);
      max-width: 760px;
      height: 88px;
      display: flex;
      flex-flow: wrap;
      overflow: hidden;
      margin-top: 0;
      background: $bg01;
      padding: 0 30px;
      transition: all .1s linear;
      position: fixed;
      top: 88px;
      z-index: 99;
      .active {
        background: $bg03;
        color: $fc02;

        .cir {
          background: $bg02;
        }
      }
      .more {
        color: $fc04 !important;
      }

      li {
        flex: 0 0 calc(20% - 10px);
        height: 80px;
        line-height: 80px;
        margin-right: 10px;
        margin-top: 4px;
        background: $bg02;
        border-radius: 15px;
        overflow: hidden;
        box-shadow: $box-shadow3;
        text-align: center;
        font-size: 28px;
        color: $fc06;
        position: relative;
        margin-bottom: 4px;
        cursor: pointer;

        .cir {
          width: 4px;
          height: 4px;
          border-radius: 4px;
          background: $bg01;
          position: absolute;
        }
        .left {
          top: 8px;
          left: 8px;
        }
        .right {
          top: 8px;
          right: 8px;
        }
        .left-down {
          bottom: 8px;
          left: 8px;
        }

        .right-down {
          right: 8px;
          bottom: 8px;
        }
      }
    }

    .category-content {
      width: calc(100% + 10px);
      height: auto;
      display: flex;
      flex-flow: wrap;
      overflow: hidden;
      // margin-top: 36px;
      background: $bg01;
      padding: 0 30px;
      box-sizing: border-box;

      li {
        flex: 0 0 calc(50% - 10px);
        height: 340px;
        padding: 4px;
        background: white;
        border-radius: $br30;
        box-shadow: $box-shadow1;
        margin-right: 10px;
        overflow: hidden;
        cursor: pointer;
        margin-bottom: 10px;
        box-sizing: border-box;

        .img-box {
          width: 100%;
          height: 256px;
          border-radius: 30px 30px 0 0;
          overflow: hidden;
        }

        .p-name {
          .group_tag{
            color: $fc04
          }
          width: 100%;
          height: 76px;
          line-height: 76px;
          font-size: 28px;
          color: $fc06;
          text-align: center;
          @include ellipsis()
        }
      }

      .van-list__finished-text, .van-list__loading {
        width: 100%;
      }

      .van-list__loading {
        display: none;
      }
    }
  }
</style>

